module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_2-da1e7e5e91d715f64f36365a53e3af4d.png";